$(document).ready(function(){

  $('.ls_select__js').click(function(){
      var currentVal = $(this).attr('data');
      if (currentVal == 'ru'){
        var newHref = $('.ls_select__js[data="ru"]').attr('data-url');
        console.log(newHref, 'NEW HREF');
        
        window.location.replace('/ru');
      }
      else{
          var currentHref = window.location.href;
          // alert(currentHref);
          var newHref = currentHref.replace('royalsperfume.lt', 'royalsperfume.'+currentVal+'')
            .replace('royalsperfume.lv', 'royalsperfume.'+currentVal+'')
            .replace('royalsperfume.ee', 'royalsperfume.'+currentVal+'')
            .replace('royalsperfume.fi', 'royalsperfume.'+currentVal+'')
            .replace('royalsperfume.se', 'royalsperfume.'+currentVal+'')
            .replace('royalsperfume.it', 'royalsperfume.'+currentVal+'')
            .replace('royalsperfume.com', 'royalsperfume.'+currentVal+'')
            .replace('royalsperfume.pl', 'royalsperfume.'+currentVal+'')
            .replace('royalsperfume.es', 'royalsperfume.'+currentVal+'').replace('/ru','');
          window.location.replace(newHref);
      }
  });

  $('.ls_select_btn').click(function(){
    $('.ls_outer').toggle();
  });
  
});

